import Model from "../Model";

class Sales extends Model{

    buildUrl ({ param }) {
        return ['retail/sales', param];
    }

    all(config = {}) {
        return this.request({ method: 'GET', action: 'all', ...config });
    }
}


export default new Sales;